import { render, staticRenderFns } from "./RecebimentoDadosNivel1Agrupado.vue?vue&type=template&id=ddddb22c"
import script from "./RecebimentoDadosNivel1Agrupado.vue?vue&type=script&lang=js"
export * from "./RecebimentoDadosNivel1Agrupado.vue?vue&type=script&lang=js"
import style0 from "./RecebimentoDadosNivel1Agrupado.vue?vue&type=style&index=0&id=ddddb22c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports